import { getBrowseById, getCurrentBrowseName } from "#skyward_browseList";
import { reportException, SkywardException } from "#skyward_error";
import { virtualDir } from "#skyward_global";
import { ButtonDefinition, ButtonIcon, ButtonText, showCriticalDialog } from "#skyward_modalLayer";
import { loadContent, registerLoadDOMCallback } from "#skyward_window";
import { setUpChangeTracking } from "./skyward.ui.changeTracking";
import { getScopeContainer, setValue } from "./skyward.ui.controls";
import { getEditableData } from "./skyward.ui.editableBrowse";
import { getSvg } from "./skyward.ui.svg";
import { Dictionary, JQueryInput } from "./types";

interface ScopingVariables
{
    fileUploadInputPrefix: string;
    fileUploadInputScoping: string;
    fileUploadCount: string;
}

type UploadRequest = Partial<{
    cancelID: string;
    deleteID: string;
    requestIsRunning: JQuery.jqXHR;
    ignoreRequest: boolean;
}>;

type Upload = XMLHttpRequestUpload & { elementNumber: string; };
interface SetImageData
{
    img?: HTMLImageElement;
    formData: FormData;
    fileUploadCount: string;
    fileCount: number;
}

interface ButtonSettings
{
    title: string;
    href: string;
    text: string;
}

(
    function (skyward, $)
    {
        skyward.fileManagement = skyward.fileManagement || {};

        let fileUploadContainersCount = 0;
        const KILOBYTE = 1024;
        const MEGABYTE = 1048576;
        const GIGABYTE = 1073741824;
        const requests: UploadRequest[] = [];

        var registerFileUploadContainers = function (selector: string)
        {
            fileUploadContainersCount++;

            ($(selector + " input.fileUploadElement") as JQuery<HTMLInputElement>).each(function (this)
            {
                let uploadInput = $<HTMLInputElement>(this);
                const scopingVariables = GetFileUploadInputScoping(uploadInput.attr('id')!);
                let { fileUploadInputPrefix, fileUploadInputScoping } = scopingVariables;
                let fileUploadCount: string | number = scopingVariables.fileUploadCount;

                if (fileUploadCount == '')
                {
                    fileUploadCount = fileUploadContainersCount;
                }

                var uploadButton = uploadInput.siblings('.uploadButton');
                var sizeLimit = Number(uploadInput.attr('data-size-limit'));
                var fileList = $('#' + fileUploadInputPrefix + 'fileList' + fileUploadInputScoping);

                var openFileUpload = function (this: HTMLInputElement)
                {
                    var button = $(this);
                    var openFileDialog = function (button: JQuery)
                    {
                        uploadInput = button.parent().find('.fileUploadElement') as JQuery<HTMLInputElement>;
                        uploadInput.val('');
                        uploadInput.trigger('click');
                    };

                    if (fileCount > 0 && !allowsMultipleFiles() && !uploadInput.hasClass("skipFileLimitError"))
                    {
                        var checkUserOk = function ()
                        {
                            var deferred = $.Deferred();

                            var okFunction = function ()
                            {
                                dialog.close();
                                deferred.resolve();
                            };

                            var cancelFunction = function ()
                            {
                                dialog.close();
                                deferred.reject();
                            };

                            const dialogButtons: ButtonDefinition[] = [
                                { text: ButtonText.Ok, icon: ButtonIcon.Check, click: okFunction },
                                { text: ButtonText.Cancel, icon: ButtonIcon.Cancel, click: cancelFunction }
                            ];

                            const dialog = showCriticalDialog("Warning", "Uploading a new document will overwrite the current document.", dialogButtons);

                            return deferred.promise();
                        };

                        $.when(checkUserOk()).done(function ()
                        {
                            openFileDialog(button);
                        });
                    }
                    else
                    {
                        openFileDialog(button);
                    }

                    return false;
                };

                uploadButton.off("click").on("click", openFileUpload);


                var fileCount = 0;
                var fNumberElement = $('#' + fileUploadInputPrefix + 'fNumber' + fileUploadInputScoping);
                const fNumberDomElement = fNumberElement.get(0);
                if (fNumberDomElement)
                {
                    fNumberDomElement.id = fileUploadInputPrefix + 'fileUpload' + fileUploadCount + 'fNumber' + fileUploadInputScoping;
                }

                var preSetFiles = uploadInput.data().files;
                if (preSetFiles !== undefined && preSetFiles.length !== 0)
                {
                    $.each(preSetFiles, function ()
                    {
                        AddHTMLToFileList(this.FileName, getFileSizeDisplay(this.FileSize), this.SessionFileUploadID, scopingVariables, uploadInput, null, undefined, this.MediaID);
                    });

                    if (fNumberElement.length > 0)
                    {
                        setValue(fNumberElement, preSetFiles.length);
                    }
                }

                var getReady = function (input: HTMLInputElement)
                {
                    const { fileUploadInputPrefix, fileUploadInputScoping } = GetFileUploadInputScoping($(uploadInput).attr('id')!);
                    const files = input.files!;

                    let fileSizeDisplay;

                    var massImportProgressBox = $('#' + fileUploadInputPrefix + 'massImportProgress' + fileUploadInputScoping);
                    if (massImportProgressBox.length > 0)
                    {
                        $(".completedWrapper").hide();
                        massImportProgressBox.parent().append($("<div>", { 'class': "uploadLoadingGifWrapper" }).append($("<img>", { 'class': "uploadLoadingGif", src: virtualDir + "content/loading.gif?v=2" })).append("Loading..."));
                    }
                    var importRunFileCount = 0;
                    $.when($(files).each(function (i)
                    {
                        $.wait(1).then(function ()
                        {
                            importRunFileCount++;
                            var fileSize = files[i].size;

                            fileSizeDisplay = getFileSizeDisplay(fileSize);

                            if (fileSize == 0)
                            {
                                const error = "This file is empty";
                                addBadFileToList(files[i].name, fileSizeDisplay, error, scopingVariables);
                                return;
                            }

                            if (fileSize > sizeLimit)
                            {
                                const error = "This file exceeded the " + getFileSizeDisplay(sizeLimit) + " limit";
                                addBadFileToList(files[i].name, fileSizeDisplay, error, scopingVariables);
                                return;
                            }

                            fileUpload(files[i], fileSizeDisplay, $(input).data().imageMode, scopingVariables, $(input), importRunFileCount);
                        });
                    }));
                };

                function GetFileUploadInputScoping(stringToSplit: string, splittingElement?: string): ScopingVariables
                {
                    let baseSplittingElement: string = "files";
                    if (!splittingElement || splittingElement.length == 0)
                    {
                        splittingElement = GetSplittingElement(stringToSplit, baseSplittingElement);
                    }

                    var fileUploadInputScoping = '';
                    var fileUploadInputPrefix = '';
                    var appendToPrefix = true;
                    if (stringToSplit && stringToSplit.length != 0)
                    {
                        const stringIDParts = stringToSplit.split('-');
                        if (stringIDParts.length > 1)
                        {
                            for (var i = 0; i < stringIDParts.length; i++)
                            {
                                if (stringIDParts[i] == splittingElement || stringIDParts[i] == baseSplittingElement)
                                {
                                    appendToPrefix = false;
                                    continue;
                                }

                                if (appendToPrefix)
                                {
                                    fileUploadInputPrefix += stringIDParts[i] + '-';
                                }
                                else
                                {
                                    fileUploadInputScoping += '-' + stringIDParts[i];
                                }
                            }
                        }

                        //for details screens
                        var index = stringToSplit?.indexOf('_') ?? -1;
                        if (index > 0)
                        {
                            if (stringToSplit.substring(0, index + 1) != fileUploadInputPrefix.substring(0, index + 1))
                            {
                                fileUploadInputPrefix = stringToSplit.substring(0, index + 1) + fileUploadInputPrefix;
                            }
                        }
                    }

                    let fileUploadCount = '';
                    const fNumberHiddenField = $('[name=' + fileUploadInputPrefix + 'fNumber' + fileUploadInputScoping + ']');

                    if (fNumberHiddenField.length > 0)
                    {
                        const fNumberHiddenFieldID = $(fNumberHiddenField[0]).attr('id')!;
                        const fNumberIDParts = fNumberHiddenFieldID.split('-');

                        for (let i = 0; i < fNumberIDParts.length; i++)
                        {
                            var currentString = fNumberIDParts[i];
                            if (currentString?.indexOf('fileUpload') > -1)
                            {
                                fileUploadCount = currentString.substring(10, currentString.lastIndexOf('fNumber'));
                            }
                        }
                    }

                    return { fileUploadInputPrefix, fileUploadInputScoping, fileUploadCount };
                };

                ///If a fileUpload is in a dataObjectViewer we need to prefix the "files" element with the DOV ID otherwise it doesn't know how to find its counter parts
                function GetSplittingElement(stringToSplit: string, baseSplittingElement: string): string
                {
                    let splittingElement = baseSplittingElement;
                    if (stringToSplit && stringToSplit.length != 0)
                    {
                        let indexOfFiles = stringToSplit.indexOf(baseSplittingElement);
                        if (indexOfFiles > 0)
                        {
                            splittingElement = stringToSplit.substring(0, indexOfFiles) + baseSplittingElement;
                        }
                        else
                        {
                            splittingElement = baseSplittingElement;
                        }
                    }
                    else
                    {
                        splittingElement = baseSplittingElement;
                    }
                    return splittingElement;
                }

                $(this).off("change").on("change", function (this: HTMLInputElement)
                {
                    getReady(this);
                });

                function setImageDimensions (file: File, imageMode: boolean, formData: FormData, fileUploadCount: string, fileCount: number): JQuery.Promise<SetImageData>
                {
                    var deferred = $.Deferred<SetImageData>();
                    if (imageMode)
                    {
                        var reader = new FileReader();
                        var img = new Image();
                        reader.readAsDataURL(file);
                        reader.onload = function (e)
                        {
                            img.src = e.target!.result as string;
                            img.addEventListener("load", function (this: HTMLImageElement)
                            {
                                formData.append('xDimension', this.width.toString());
                                formData.append('yDimension', this.height.toString());

                                deferred.resolve({ img: img, formData: formData, fileUploadCount: fileUploadCount, fileCount: fileCount });
                            });
                        };

                    }
                    else
                    {
                        deferred.resolve({ formData: formData, fileUploadCount: fileUploadCount, fileCount: fileCount });
                    }
                    return deferred.promise();
                }

                var escapeIDAsSelector = function (id: string)
                {
                    return "#" + CSS.escape(id);
                };

                function fileUpload(file: File, fileSize: string, imageMode: boolean, scopingVariables: ScopingVariables, inputElement: JQuery<HTMLInputElement>, importRunFileCount: number)
                {
                    const { fileUploadInputPrefix, fileUploadInputScoping, fileUploadCount } = scopingVariables;

                    if (imageMode && file.type.indexOf('image/') !== 0)
                    {
                        return;
                    }

                    addToFileList(file, fileSize, scopingVariables, inputElement, importRunFileCount);
                    $(escapeIDAsSelector(fileUploadInputPrefix + 'fileUpload' + fileUploadCount + 'fNumber' + fileUploadInputScoping)).val(fileCount);

                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('fileCount', fileCount.toString());
                    formData.append("securityHash", uploadInput.data("securityHash"));
                    formData.append("encryptFiles", (uploadInput.data("encryptFileData") === true).toString());

                    $.when(setImageDimensions(file, imageMode, formData, fileUploadCount, fileCount)).done(function (setImageData)
                    {
                        var request: Partial<UploadRequest> = {} as unknown as any;
                        request.cancelID = fileUploadInputPrefix + "Cancel" + setImageData.fileUploadCount + setImageData.fileCount + fileUploadInputScoping;
                        request.deleteID = fileUploadInputPrefix + "Delete" + setImageData.fileUploadCount + setImageData.fileCount + fileUploadInputScoping;
                        request.requestIsRunning = $.ajax(
                            {
                                url: virtualDir + 'Security/SessionFileUpload/' + 'CreateSessionFileUpload',
                                type: "POST",
                                xhr: function ()
                                { // Custom XMLHttpRequest
                                    var myXhr = $.ajaxSettings.xhr!();
                                    if (myXhr.upload)
                                    { // Check if upload property exists
                                        const upload = myXhr.upload as Upload;
                                        upload.elementNumber = "" + setImageData.fileUploadCount + setImageData.fileCount;
                                        upload.addEventListener('progress', progressHandlingFunction as (ev: ProgressEvent) => void, false); // For handling the progress of the upload
                                    }
                                    return myXhr;
                                },
                                success: function (data)
                                {
                                    var fileUploadInputSelector = fileUploadInputPrefix + 'file' + setImageData.fileUploadCount + data.fileNumber + fileUploadInputScoping;
                                    var fileUploadInput = $(escapeIDAsSelector(fileUploadInputSelector));
                                    fileUploadInput.find('.button').remove();
                                    fileUploadInput.find('.fileID').val(data.id);
                                    var fileUploadInputSelectorName = $(escapeIDAsSelector(fileUploadInputPrefix + "fileUploadInputSelectorName"));
                                    if (fileUploadInputSelectorName.length > 0)
                                    {
                                        fileUploadInputSelectorName.val(fileUploadInputSelector);
                                    }
                                    var closeIconSpan = $('<span/>');
                                    $.when(getSvg('Delete', 'Control')).done(function (svg)
                                    {
                                        closeIconSpan.append(svg);
                                        getDeleteButton(setImageData.fileUploadCount + data.fileNumber, closeIconSpan.html(), scopingVariables).appendTo($('#' + fileUploadInputPrefix + "file" + fileUploadCount + data.fileNumber + fileUploadInputScoping)).on("click", deleteFiles);
                                    });

                                    if (!inputElement.data().massImportMode)
                                    {
                                        $(".uploadLoadingGifWrapper").hide();
                                        $(".completedWrapper").show();
                                    }
                                },
                                data: setImageData.formData,
                                // TODO is this a load-bearing typo? the correct capitalization is dataType, datatype is ignored
                                //datatype: 'multipart/form-data',
                                contentType: false,
                                processData: false,
                                async: true
                            });
                        requests.push(request);
                    });
                }

                function getRemoveButton(type: string, fileNumber: string, innerHtml: JQueryInput, scopingVariables: ScopingVariables, options?: Partial<ButtonSettings>)
                {
                    const { fileUploadInputPrefix, fileUploadInputScoping } = scopingVariables;

                    var defaults =
                    {
                        title: "Deletes the selected file",
                        href: "javascript:void(0)",
                        'class': "fileUpload__deleteButton",
                        text: "Delete File"
                    };
                    var settings: ButtonSettings = $.extend({}, defaults, options);

                    var button = $('<a>',
                        {
                            id: fileUploadInputPrefix + type + fileNumber + fileUploadInputScoping,
                            'class': "fileUpload__deleteButton button",
                            title: settings.title,
                            alt: settings.title,
                            'data-value-input-id': fileUploadInputPrefix +"fileInput" + fileNumber + fileUploadInputScoping,
                            href: settings.href,
                            html: innerHtml
                        });
                    button.append(document.createTextNode(settings.text));
                    return button;
                }

                function getDeleteButton(fileNumber: string, innerHtml: JQueryInput, scopingVariables: ScopingVariables, options?: Partial<ButtonSettings>)
                {
                    return getRemoveButton('Delete', fileNumber, innerHtml, scopingVariables, options);
                }

                function getCancelButton(fileNumber: string, innerHtml: JQueryInput, scopingVariables: ScopingVariables, options?: Partial<ButtonSettings>)
                {
                    return getRemoveButton('Cancel', fileNumber, innerHtml, scopingVariables, options);
                }

                function updateCurrentVal(scopingVariables: ScopingVariables)
                {
                    const { fileUploadInputPrefix, fileUploadInputScoping, fileUploadCount } = scopingVariables;
                    var fileCountControl = $('#' + fileUploadInputPrefix + 'fileUpload' + fileUploadCount + 'fNumber' + fileUploadInputScoping) as JQuery<HTMLInputElement>;
                    if (fileCountControl.length > 0)
                    {
                        fileCountControl.val(parseInt(fileCountControl.val() as string, 10) - 1);
                        fileCountControl.trigger('change');
                    }
                }

                function removeFileContainer(file: string)
                {
                    var selectorParts = file.split('-');
                    var splittingElement = '';

                    for (var i = 0; i < selectorParts.length; i++)
                    {
                        if (selectorParts[i].indexOf('Delete') > -1)
                        {
                            splittingElement = selectorParts[i];
                        }
                    }

                    const scopingVariables = GetFileUploadInputScoping(file, splittingElement)
                    const container = $('#' + file).parent();

                    // Un-dirty the input
                    var input = container.find("input");
                    input.data('original-value', input.val()!);
                    input.trigger("dirty");

                    container.remove();

                    fileCount--;

                    updateCurrentVal(scopingVariables);
                }

                function cancel (event: JQuery.ClickEvent)
                {
                    var id = event.target.id;
                    var thisRequest;
                    for (var i = 0; i < requests.length; i++)
                    {
                        if (requests[i].cancelID == id)
                        {
                            thisRequest = requests[i];
                            requests.splice(i, 1);
                        }
                    }
                    if (thisRequest == null)
                    {
                        return;
                    }

                    if (thisRequest.requestIsRunning && thisRequest.requestIsRunning.readyState != 4)
                    {
                        thisRequest.requestIsRunning.abort();
                        removeFileContainer(id);
                    }
                    else
                    {
                        showCriticalDialog("Error", "The upload has completed or no files are being uploaded currently");
                    }
                };

                function getSessionFileUploadIDFromFileIDInput(fileIDInput: JQuery<HTMLInputElement>)
                {
                    const inputName = fileIDInput.attr("name")!;
                    const inputHasFileIsMediaIndicator = inputName?.indexOf("media") >= 0;
                    return inputHasFileIsMediaIndicator ? undefined : fileIDInput.val();
                };

                function deleteFiles(event: JQuery.ClickEvent)
                {
                    const deleteButton = $(event.target).closest(".button");
                    const id = deleteButton.attr("id")!;

                    var thisRequest;
                    for (let i = 0; i < requests.length; i++)
                    {
                        if (requests[i].deleteID == id)
                        {
                            thisRequest = requests[i];
                            requests.splice(i, 1);
                        }
                    }

                    var sessionFileUploadID = getSessionFileUploadIDFromFileIDInput($('#' + id).siblings('.fileID') as JQuery<HTMLInputElement>);

                    var data = { "sessionFileUploadID": sessionFileUploadID, "securityHash": uploadInput.data("securityHash") };

                    if (thisRequest == null || !data.sessionFileUploadID)
                    {
                        return;
                    }

                    var value = $(deleteButton.data().valueInputId);
                    deleteButton.data().deletingValue = value.val();
                    value.val('');

                    if (thisRequest.ignoreRequest || (thisRequest.requestIsRunning && thisRequest.requestIsRunning.readyState == 4))
                    {
                        $.ajax(
                            {
                                url: virtualDir + "Security/SessionFileUpload/" + "DeleteSessionFileUpload",
                                type: "POST",
                                data: data,
                                success: function ()
                                {
                                    removeFileContainer(id);
                                },
                                error: function ()
                                {
                                    value.val(deleteButton.data().deletingValue);
                                    showCriticalDialog("Error", "File failed to delete");
                                }
                            });
                    }
                    else
                    {
                        showCriticalDialog("Error", "There is no file to delete");
                    }
                };

                function progressHandlingFunction (this: Upload, e: ProgressEvent)
                {
                    if (e.lengthComputable)
                    {
                        $('#progressbar' + this.elementNumber).progressbar({ value: Math.round(e.loaded / e.total * 100) });
                    }
                };

                function deleteMultiples(scopingVariables: ScopingVariables)
                {
                    const { fileUploadInputPrefix, fileUploadInputScoping } = scopingVariables;

                    var fileList = $('#' + fileUploadInputPrefix + 'fileList' + fileUploadInputScoping);
                    var id = fileList.children('.file').children(".button").attr("id")!;
                    var thisRequest;
                    for (var i = 0; i < requests.length; i++)
                    {
                        if (requests[i].deleteID == id || requests[i].cancelID == id)
                        {
                            thisRequest = requests[i];
                            requests.splice(i, 1);
                        }
                    }

                    var sessionFileUploadID = getSessionFileUploadIDFromFileIDInput(fileList.find(".fileID") as JQuery<HTMLInputElement>);

                    var data = { "sessionFileUploadID": sessionFileUploadID, "securityHash": uploadInput.data("securityHash") };
                    removeFileContainer(id);

                    if (thisRequest == null || !data.sessionFileUploadID)
                    {
                        return;
                    }

                    if (thisRequest.ignoreRequest || (thisRequest.requestIsRunning && thisRequest.requestIsRunning.readyState == 4))
                    {
                        $.ajax(
                            {
                                url: virtualDir + "Security/SessionFileUpload/" + "DeleteSessionFileUpload",
                                type: "POST",
                                data: data,
                                error: function ()
                                {
                                    showCriticalDialog("Error", "File failed to delete");
                                }
                            });
                    }
                    else
                    {
                        showCriticalDialog("Error", "There is no file to delete");
                    }
                };

                function addToFileList(file: File, fileSize: string, scopingVariables: ScopingVariables, inputElement: JQuery<HTMLInputElement>, importRunFileCount: number)
                {
                    if (fileCount > 0 && !allowsMultipleFiles())
                    {
                        deleteMultiples(scopingVariables);
                    }
                    AddHTMLToFileList(file.name, fileSize, undefined, scopingVariables, inputElement, file, importRunFileCount, undefined);
                };

                function AddHTMLToFileList(fileName: string, fileSize: string, sessionFileUploadID: string | undefined | null, scopingVariables: ScopingVariables, inputElement: JQuery<HTMLInputElement>, file: File | null, importRunFileCount: number | undefined, mediaID: string | number | undefined | null)
                {
                    const { fileUploadInputPrefix, fileUploadInputScoping, fileUploadCount } = scopingVariables;
                    var fileList = $('#' + fileUploadInputPrefix + 'fileList' + fileUploadInputScoping);

                    var hasExistingSessionFileUpload = sessionFileUploadID !== undefined && sessionFileUploadID !== null;
                    var isPreviouslyUploadedFile = mediaID !== undefined && mediaID !== null;
                    var fileIsMediaIndicator = isPreviouslyUploadedFile ? "media" : "";
                    var isExistingFile = hasExistingSessionFileUpload || isPreviouslyUploadedFile;

                    fileCount++;

                    var fileIdentifier = fileUploadCount.toString() + fileCount.toString();

                    var fileIDInput = $("<input>", {
                        id: fileUploadInputPrefix + "fileInput" + fileIdentifier + fileUploadInputScoping,
                        'class': "fileID",
                        type: "hidden",
                        name: fileUploadInputPrefix + "file" + fileIdentifier + fileUploadInputScoping + fileIsMediaIndicator,
                        'data-original-value': ""
                    });

                    if (inputElement.data().massImportMode)
                    {
                        var html = $("<div>", { id: fileUploadInputPrefix + "file" + fileIdentifier + fileUploadInputScoping, 'class': "file hidden" });
                        html.append(fileIDInput);
                        fileList.append(html);

                        var massImportProgressBox = $('#' + fileUploadInputPrefix + 'massImportProgress' + fileUploadInputScoping);
                        if (massImportProgressBox.length > 0)
                        {
                            massImportProgressBox.val(fileCount);

                            const inputDomElement = inputElement.get(0);

                            if (inputDomElement !== undefined && importRunFileCount == inputDomElement.files!.length)
                            {
                                $(".uploadLoadingGifWrapper").hide();
                                massImportProgressBox.parent().append($("<div>", { 'class': "completedWrapper" }).append($("<span>", { 'class': "checkmarkIcon" })).append("Completed"));
                                $.when(getSvg('Check', 'MessageBox')).done(function (svg)
                                {
                                    $(".checkmarkIcon").html(svg[0]);
                                });
                            }
                        }
                        return;
                    }

                    if (isExistingFile)
                    {
                        var request: Partial<UploadRequest> = {};
                        request.deleteID = fileUploadInputPrefix + "Delete" + fileIdentifier + fileUploadInputScoping;
                        request.ignoreRequest = true;
                        requests.push(request as UploadRequest);

                        if (!isPreviouslyUploadedFile)
                        {
                            fileIDInput.val(sessionFileUploadID!);
                        }
                        else
                        {
                            fileIDInput.val(mediaID!);
                        }
                    }
                    else
                    {
                        $('#progressbar' + fileIdentifier).progressbar({ value: 0 });

                        fileIDInput.val("noFileId");  // Trigger dirty logic
                    }

                    var html = $("<div>", { id: fileUploadInputPrefix + "file" + fileIdentifier + fileUploadInputScoping, 'class': "file" });

                    if (inputElement.hasClass("showEmbeddedImage"))
                    {
                        html.append($("<img>", { 'class': "embeddedImageDisplay displayBlock" }));
                    }
                    else
                    {
                        html.append($("<span>", { 'class': "defaultIcon" }));
                    }

                    if (!inputElement.hasClass("hideFileUploadName"))
                    {
                        html.append($("<span>", { 'class': "fileuploadname" }).text(fileName));
                    }
                    html.append($("<span>", { 'class': "fileSizeDisplay" }).text("(" + fileSize + ")"));
                    html.append($("<div>", { 'class': "completedWrapper" }).append($("<span>", { 'class': "checkmarkIcon" })).append("Completed"));
                    html.append(fileIDInput);
                    html.append($("<div>", { 'class': "uploadLoadingGifWrapper" }).append($("<img>", { 'class': "uploadLoadingGif", src: virtualDir + "content/loading.gif?v=2" })).append("Loading..."));

                    var button = getCancelOrDeleteButton(isExistingFile, fileIdentifier, scopingVariables);
                    if (inputElement.data().replaceFileMode)
                    {
                        button.css("display", "none");
                    }
                    html.append(button);

                    if (inputElement.hasClass("showEmbeddedImage"))
                    {
                        var img = new Image();

                        img.addEventListener("load", function ()
                        {
                            var inputElementData = inputElement.data();
                            if (inputElementData.embeddedImageMaxWidth)
                            {
                                if (this.width > parseInt(inputElementData.embeddedImageMaxWidth))
                                {
                                    var originalWidth = this.width;
                                    this.width = parseInt(inputElementData.embeddedImageMaxWidth);
                                    var ratio = this.width / originalWidth;
                                    this.height = ratio * this.height;
                                }
                            }
                            if (inputElementData.embeddedImageMaxHeight)
                            {
                                if (this.width > parseInt(inputElementData.embeddedImageMaxHeight))
                                {
                                    var originalHeight = this.height;
                                    this.height = parseInt(inputElementData.embeddedImageMaxHeight);
                                    var ratio = this.height / originalHeight;
                                    this.width = ratio * this.width;
                                }
                            }

                            html.find('.embeddedImageDisplay')
                                .attr('src', this.src)
                                .width(this.width)
                                .height(this.height);

                            inputElement.trigger("embeddedImagedLoaded");
                        });

                        img.src = window.URL.createObjectURL(file!);
                    }

                    fileList.append(html);
                    if (!inputElement.hasClass("showEmbeddedImage"))
                    {
                        $.when(getSvg('Default', 'Reporting')).done(function (svg)
                        {
                            $(".defaultIcon").html(svg[0]);
                        });
                    }
                    $.when(getSvg('Check', 'MessageBox')).done(function (svg)
                    {
                        $(".checkmarkIcon").html(svg[0]);
                    });
                    if (isExistingFile)
                    {
                        $.when(getSvg('Delete', 'Control')).done(function (svg)
                        {
                            $(".deleteIcon").html(svg[0]);
                        });
                    }
                    else
                    {
                        $.when(getSvg('Cancel', 'Control')).done(function (svg)
                        {
                            $(".cancelIcon").html(svg[0]);
                        });
                    }

                    $('#' + fileUploadInputPrefix + "Delete" + fileIdentifier + fileUploadInputScoping).on("click", deleteFiles);
                    $('#' + fileUploadInputPrefix + 'Cancel' + fileIdentifier + fileUploadInputScoping).on("click",  cancel);
                    fileList.find(".CheckBox").addClass("svgNoHover");
                    if (isExistingFile)
                    {
                        fileList.find(".uploadLoadingGifWrapper").hide();
                    }
                    else
                    {
                        fileList.find(".completedWrapper").hide();
                    }

                    if (!hasExistingSessionFileUpload)
                    {
                        // Dirty the input when upload begins
                        setUpChangeTracking(fileUploadInputPrefix + 'fileInput' + fileIdentifier + fileUploadInputScoping);
                        fileIDInput.trigger("dirty");
                    }
                    getScopeContainer(fileList).trigger('fileAdded', [scopingVariables]);
                };

                function getCancelOrDeleteButton(getDelete: boolean, fileNumber: string, scopingVariables: ScopingVariables)
                {
                    const button = getDelete ?
                        getDeleteButton(fileNumber, $("<span>", { 'class': "deleteIcon" }), scopingVariables) :
                        getCancelButton(fileNumber, $("<span>", { 'class': "cancelIcon" }), scopingVariables, { title: "Cancels the upload of selected file", text: "Cancel Upload" });

                    return button;
                }

                function addBadFileToList(file: string, fileSize: string, error: string, scopingVariables: ScopingVariables)
                {
                    const { fileUploadInputPrefix, fileUploadInputScoping, fileUploadCount } = scopingVariables;

                    var fileNumber = fileUploadCount.toString() + fileCount.toString();

                    if (fileCount > 0 && !allowsMultipleFiles())
                    {
                        deleteMultiples(scopingVariables);
                    }

                    var cancelIconSpan = $('<span/>');
                    $.when(getSvg('Delete', 'Control')).done(function (svg)
                    {
                        cancelIconSpan.append(svg);
                    });

                    fileCount++;

                    var html = $("<div>", { id: fileUploadInputPrefix + "file" + fileNumber + fileUploadInputScoping, 'class': "file" });
                    html.append($("<span>", { 'class': "badfileuploadname" }).text(file));
                    html.append($("<span>", { 'class': "badFileSizeDisplay" }).text("(" + fileSize + ")"));
                    html.append($("<span>", { 'class': "filetoolargemessage" }).text(error));
                    html.append(getDeleteButton(fileNumber, cancelIconSpan, scopingVariables));

                    fileList.append(html);

                    $('#' + fileUploadInputPrefix + 'Delete' + fileNumber + fileUploadInputScoping).on("click", function ()
                    {
                        if (this.id)
                        {
                            removeFileContainer(this.id);
                            return false;
                        }

                        reportException(new SkywardException("File has invalid or missing ID and couldn't be removed.", `File: ${file}`));
                        return undefined;
                    });
                };

                function allowsMultipleFiles ()
                {
                    return uploadInput.prop('multiple');
                };

                function getFileSizeDisplay (fileSize: number)
                {
                    if (fileSize === 0)
                    {
                        return "0KB";
                    }
                    else if ((fileSize / KILOBYTE) < 1)
                    {
                        return "1KB";
                    }
                    else if ((fileSize / KILOBYTE) >= 1 && (fileSize / KILOBYTE) < 1024)
                    {
                        return Math.round(fileSize / KILOBYTE) + "KB";
                    }
                    else if ((fileSize / MEGABYTE) >= 1 && (fileSize / MEGABYTE) < 1024)
                    {
                        return Math.round(fileSize / MEGABYTE) + "MB";
                    }
                    else
                    {
                        return Math.round(fileSize / GIGABYTE) + "GB";
                    }
                }
            });
        };

        skyward.fileManagement.fileIsUploading = function ()
        {
            return requests.some(request => !request.ignoreRequest && (request.requestIsRunning && request.requestIsRunning.readyState != 4));
        };

        skyward.fileManagement.export = function (event: MouseEvent)
        {
            var target = $(event.currentTarget! as Element);
            var exportArea = target.data("export-area");
            var exportController = target.data("export-controller");
            var exportAction = target.data("export-action");
            var exportData = target.data("export-data") || {};
            var mediaVerificationToken = target.data("media-verification-token");
            var mediaID = target.data("media-id");

            var data: Dictionary<string, any> = {};

            for (var propName in exportData)
            {
                data[propName] = exportData[propName];
            }

            const browse = getBrowseById(getCurrentBrowseName());
            if (browse && browse.browseName)
            {
                data[browse.browseName] = getEditableData(browse.browseName);
            }
            loadContent("popout", exportArea, exportController, exportAction, mediaID, data, null, undefined, null, false, null, null, mediaVerificationToken);
        };

        skyward.fileManagement.getFileData = function (wrapperContainer)
        {
            var fileIDIsDirty = wrapperContainer.find(".fileID[data-dirty='true']").length > 0;

            var fileUploadElement = wrapperContainer.find(".fileUploadElement");
            if (fileUploadElement.length > 0)
            {
                var files = fileUploadElement.data().files;
                if (files && !fileIDIsDirty)
                {
                    var fileUploadElementName = fileUploadElement.attr("name");
                    return { name: fileUploadElementName!, file: files[files.length - 1] };
                }
            }
            return null;
        }

        registerLoadDOMCallback(registerFileUploadContainers);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
